module.exports = __webpack_public_path__ + "img/建设银行@2x.afc3a051.png";